<template>
  <div :class="[`x1-51-item-1`, className || ``]">
    <div class="view-463">
      <div class="rectangle-203-2"></div>
      <div class="text-46-1 poppins-bold-black-20px">Запланировано</div>
    </div>
    <div class="text-463 poppins-normal-thunder-20px">{{ text1754 }}</div>
    <div class="date-2 poppins-normal-thunder-20px">{{ date }}</div>
  </div>
</template>

<script>
export default {
  name: "X292",
  props: ["text1754", "date", "className"],
};
</script>

<style>
.x1-51-item-1 {
  display: flex;
  margin-left: 29px;
  margin-top: 9px;
  width: 430px;
}

.view-463 {
  align-self: center;
  height: 40px;
  position: relative;
  width: 207px;
}

.rectangle-203-2 {
  background-color: var(--black-6);
  border-radius: 10px;
  height: 40px;
  left: 0;
  position: absolute;
  top: calc(50% - 20px);
  width: 205px;
}

.text-46-1 {
  left: 19px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 5px;
}

.text-463 {
  height: 30px;
  letter-spacing: 1px;
  line-height: normal;
  margin-left: 48px;
  margin-top: 5px;
  width: 53px;
}

.date-2 {
  height: 30px;
  letter-spacing: 1px;
  line-height: normal;
  margin-left: 34px;
  margin-top: 5px;
  width: 84px;
}

.x1-51-item-1.x1-51-item .text-463,
.x1-51-item-1.x1-55-item .text-463 {
  width: 59px;
}

.x1-51-item-1.x1-51-item .date-2,
.x1-51-item-1.x1-55-item .date-2 {
  margin-left: 28px;
}
</style>
